import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://orders.getsquarefare.com/api',
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add request interceptor for debugging
instance.interceptors.request.use(
    (config) => {
        //console.log('Making request to:', config.baseURL + config.url);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

export default instance;
